import { Alert, Row, Table, Pagination, Col } from "react-bootstrap";
import { useTable, usePagination, useSortBy } from "react-table";

import React, { useState } from "react";

const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

export const Lists = ({ columns, rawData, pagination }) => {
    const {
        meta,
        links,
        page_total,
        grand_total,
        data: groupedCompaniesWrapper = {},
    } = rawData;

    // Extract the actual array of companies
    const groupedCompanies = groupedCompaniesWrapper.data || [];

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        state: {
            pageSize,
            canNextPage,
            canPreviousPage,
            totalPage,
            currentPage,
            firstPage,
            lastPage,
        },
    } = useTable(
        {
            columns,
            data: groupedCompanies,
            initialState: {
                pageIndex: 0,
                pageSize: meta?.per_page,
                canNextPage: links?.next !== null ? true : false,
                canPreviousPage: links?.prev !== null ? true : false,
                totalPage: meta?.last_page,
                currentPage: meta?.current_page,
                firstPage: meta?.first,
                lastPage: meta?.last_page,
            },
        },
        useSortBy,
        usePagination
    );

    const gotoPage = (page) => {
        pagination({ page });
    };

    const [expandedRowId, setExpandedRowId] = useState(null);

    const toggleRow = (id) => {
        setExpandedRowId((prev) => (prev === id ? null : id));
    };

    return (
        <>
            {groupedCompanies.length > 0 && (
                <Row>
                    {totalPage > 1 && (
                        <Row className="fixed-header-w-navbar py-3">
                            <Col className="d-flex justify-content-end align-items-center gap-3 py-2">
                                <span className="text-muted">
                                    Page <strong>{currentPage}</strong> of{" "}
                                    <strong>{totalPage}</strong>
                                </span>
                                <Pagination className="mb-0">
                                    <Pagination.First
                                        onClick={() => gotoPage(firstPage)}
                                        disabled={!canPreviousPage}
                                    />
                                    <Pagination.Prev
                                        onClick={() =>
                                            gotoPage(currentPage - 1)
                                        }
                                        disabled={!canPreviousPage}
                                    />
                                    <Pagination.Next
                                        onClick={() =>
                                            gotoPage(currentPage + 1)
                                        }
                                        disabled={!canNextPage}
                                    />
                                    <Pagination.Last
                                        onClick={() => gotoPage(lastPage)}
                                        disabled={!canNextPage}
                                    />
                                </Pagination>
                            </Col>
                        </Row>
                    )}

                    <Table responsive striped bordered {...getTableProps()}>
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th
                                            {...column.getHeaderProps(
                                                column.getSortByToggleProps()
                                            )}
                                        >
                                            {column.render("Header")}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, i) => {
                                prepareRow(row);
                                const isExpanded =
                                    expandedRowId === row.original.company_id;

                                // console.log(row.original);
                                return (
                                    <React.Fragment key={row.original.id}>
                                        <tr
                                            {...row.getRowProps()}
                                            style={{
                                                borderLeft: isExpanded
                                                    ? "4px solid #007bff"
                                                    : "4px solid transparent",
                                                borderRight: isExpanded
                                                    ? "4px solid #007bff"
                                                    : "4px solid transparent",
                                            }}
                                        >
                                            {row.cells.map((cell, index) => {
                                                if (index === 0) {
                                                    return (
                                                        <td
                                                            key={index}
                                                            style={{
                                                                width: "80px",
                                                                whiteSpace:
                                                                    "nowrap",
                                                            }}
                                                        >
                                                            {currentPage > 1
                                                                ? (currentPage -
                                                                      1) *
                                                                      pageSize +
                                                                  i +
                                                                  1
                                                                : i + 1}
                                                        </td>
                                                    );
                                                }
                                                return (
                                                    <td
                                                        {...cell.getCellProps()}
                                                        className="cursor-pointer"
                                                        onClick={() =>
                                                            toggleRow(
                                                                row.original
                                                                    .company_id
                                                            )
                                                        } // <-- use outer row
                                                    >
                                                        {cell.render("Cell")}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                        {isExpanded && (
                                            <>
                                                {row.original.invoices?.length > 0 && (
                                                    <tr key="invoices">
                                                        <td
                                                            colSpan={
                                                                row.cells
                                                                    .length
                                                            }
                                                        >
                                                            <div className="p-3 bg-light border-top">
                                                                <strong>Invoice</strong>
                                                                <Table striped bordered size="sm" className="mb-0 mt-2">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Document Number</th>
                                                                            <th>Document Date</th>
                                                                            <th>Amount</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {row.original.invoices.map(
                                                                            (
                                                                                inv
                                                                            ) => (
                                                                                <tr
                                                                                    key={`inv-${inv.document_number}`}
                                                                                >
                                                                                    <td>
                                                                                        {inv.origin ===
                                                                                        "TMS" ? (
                                                                                            <a
                                                                                                href={`/tms/invoices/view/${inv.id}?option=view&page=1&type=operation`}
                                                                                                target="_blank"
                                                                                                rel="noopener noreferrer"
                                                                                            >
                                                                                                {
                                                                                                    inv.document_number
                                                                                                }
                                                                                            </a>
                                                                                        ) : (
                                                                                            inv.document_number
                                                                                        )}
                                                                                    </td>
                                                                                    <td>
                                                                                        {formatDate(
                                                                                            inv.date
                                                                                        )}
                                                                                    </td>
                                                                                    <td>
                                                                                        {Number(
                                                                                            inv.remaining_amount
                                                                                        ).toLocaleString(
                                                                                            "en-US",
                                                                                            {
                                                                                                minimumFractionDigits: 2,
                                                                                                maximumFractionDigits: 2,
                                                                                            }
                                                                                        )}
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        )}
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}

                                                {row.original.credit_notes?.length > 0 && (
                                                    <tr key="credit-notes">
                                                        <td
                                                            colSpan={
                                                                row.cells
                                                                    .length
                                                            }
                                                        >
                                                            <div className="p-3 bg-light border-top">
                                                                <strong>Credit Notes</strong>
                                                                <Table striped bordered size="sm" className="mb-0 mt-2">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Document Number</th>
                                                                            <th>Document Date</th>
                                                                            <th>Amount</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {row.original.credit_notes.map(
                                                                            (
                                                                                cn
                                                                            ) => (
                                                                                <tr
                                                                                    key={`cn-${cn.origin}-${cn.id}`}
                                                                                >
                                                                                    <td>
                                                                                        {cn.origin ===
                                                                                        "TMS" ? (
                                                                                            <a
                                                                                                href={`/tms/credit-note-view/summary-credit-notes/${cn.id}?option=view&page=1&status=summary`}
                                                                                                target="_blank"
                                                                                                rel="noopener noreferrer"
                                                                                            >
                                                                                                {
                                                                                                    cn.document_number
                                                                                                }
                                                                                            </a>
                                                                                        ) : (
                                                                                            cn.document_number
                                                                                        )}
                                                                                    </td>
                                                                                    <td>
                                                                                        {formatDate(
                                                                                            cn.date
                                                                                        )}
                                                                                    </td>
                                                                                    <td>
                                                                                        {Number(
                                                                                            cn.remaining_amount
                                                                                        ).toLocaleString(
                                                                                            "en-US",
                                                                                            {
                                                                                                minimumFractionDigits: 2,
                                                                                                maximumFractionDigits: 2,
                                                                                            }
                                                                                        )}
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        )}
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            <tr>
                                <td></td>
                                <td className="fw-bold">
                                    Total Net Unpaid Invoice amount
                                </td>
                                <td>
                                    {Number(grand_total).toLocaleString(
                                        "en-US",
                                        {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        }
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                    {totalPage > 1 && (
                        <Row className="fixed-header-w-navbar py-3">
                            <Col className="d-flex justify-content-end align-items-center gap-3 py-2">
                                <span className="text-muted">
                                    Page <strong>{currentPage}</strong> of{" "}
                                    <strong>{totalPage}</strong>
                                </span>
                                <Pagination className="mb-0">
                                    <Pagination.First
                                        onClick={() => gotoPage(firstPage)}
                                        disabled={!canPreviousPage}
                                    />
                                    <Pagination.Prev
                                        onClick={() =>
                                            gotoPage(currentPage - 1)
                                        }
                                        disabled={!canPreviousPage}
                                    />
                                    <Pagination.Next
                                        onClick={() =>
                                            gotoPage(currentPage + 1)
                                        }
                                        disabled={!canNextPage}
                                    />
                                    <Pagination.Last
                                        onClick={() => gotoPage(lastPage)}
                                        disabled={!canNextPage}
                                    />
                                </Pagination>
                            </Col>
                        </Row>
                    )}
                </Row>
            )}
            {groupedCompanies.length === 0 && (
                <Alert variant="warning">
                    <div className="alert-message">No Data</div>
                </Alert>
            )}
        </>
    );
};
